import { render } from "./getPass.vue?vue&type=template&id=81278298"
import script from "./getPass.vue?vue&type=script&lang=js"
export * from "./getPass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__